import api from '@/apis/dashboard/dashboardBudgetPlanImplementationAPI';
import Chart from '@/stores/baseChart';
const chart = new Chart('budgetPlanImplementation', api);

const state = {
  ...chart.state,
  avaItems: []
};
const getters = {
  ...chart.getters,
};
const actions = {
  ...chart.actions,
  /**
   * Load dữ liệu chart cho ava phân tích
   * @param {*} context context
   * @param {*} payload payload
   * NBTIN 03.06.2024
   */
  async avaLoad(context, payload) {
    let res = null;
    if (!api) {
      throw new Error('Chưa khai báo api');
    }
    if (typeof api.getChartDataMisaAva !== 'function') {
      throw new Error('Chưa định nghĩa hàm getChartDataMisaAva');
    }
    try {
      context.commit('updateLoading', true);
      res = await api.getChartDataMisaAva(payload || {});
      if (res && res.Data) {
        context.commit('setAvaItems', res.Data?.currentMonthData);
      } else {
        console.warn('Chart Data empty');
      }
    } finally {
      context.commit('updateLoading', false);
    }
    return res;
  },
   /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * NBTIN 03.06.2024
   */
  setAvaItems(context, payload) {
    context.commit('setAvaItems', payload);
  },
};
const mutations = {
  ...chart.mutations,
  setAvaItems(state, data) {
    state.avaItems = data;
  },
};

export default {
  // eslint-disable-next-line no-undef
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};